import { Column } from "@/components/Datatable/types";
import { ProductsHistoryReportItem } from "../../api/fetchProductsHistoryReport/types";

function titleCase(status: string): string {
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// orderDate arrives as an ISO 8601 datetime; the report shows the date part,
// matching the Y-m-d format the sibling reports render.
function formatOrderDate(orderDate: string | null): string {
  return orderDate ? orderDate.slice(0, 10) : "";
}

export function productsHistoryReportColumns(): Column<ProductsHistoryReportItem>[] {
  return [
    {
      header: "Company Name",
      accessorKey: "companyName",
      enableSorting: true,
      cell: ({ row }) => row.original.companyName,
    },
    {
      header: "Intacct ID",
      accessorKey: "intacctId",
      cell: ({ row }) => row.original.intacctId ?? "",
    },
    {
      header: "Category",
      // Sort id must be categoryName (the backend sortBy whitelist key);
      // the response field itself is category.
      id: "categoryName",
      accessorKey: "category",
      enableSorting: true,
      cell: ({ row }) => row.original.category ?? "",
    },
    {
      header: "Product Name",
      accessorKey: "productName",
      enableSorting: true,
      cell: ({ row }) => row.original.productName,
    },
    {
      header: "Quantity",
      accessorKey: "quantity",
      enableSorting: true,
      cell: ({ row }) => row.original.quantity,
    },
    {
      header: "Order Date",
      accessorKey: "orderDate",
      enableSorting: true,
      cell: ({ row }) => formatOrderDate(row.original.orderDate),
    },
    {
      header: "Unit Price",
      accessorKey: "unitPrice",
      enableSorting: true,
      cell: ({ row }) => `$${row.original.unitPrice}`,
    },
    {
      header: "Line Total",
      accessorKey: "lineTotal",
      enableSorting: true,
      cell: ({ row }) => `$${row.original.lineTotal}`,
    },
    {
      header: "Status",
      accessorKey: "status",
      enableSorting: true,
      cell: ({ row }) => titleCase(row.original.status),
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: ({ row }) => row.original.email ?? "",
    },
  ];
}
